<script lang="ts" setup>
const props = defineProps<{
  name: string
  label?: string
  description?: string
  placeholder?: string
}>()

defineOptions({
  inheritAttrs: false,
})

const { value, errorMessage } = useField<boolean>(props.name)
</script>

<template>
  <UiFormField
    keep-value
    :name="name"
  >
    <UiFormItem class="flex items-center gap-2">
      <UiFormControl>
        <UiSwitch
          v-model="value"
          class="mt-3"
          v-bind="{ ...$attrs }"
        />
      </UiFormControl>
      <div class="space-y-2">
        <UiFormLabel>{{ label }}</UiFormLabel>
        <UiFormDescription v-if="description || $slots.description">
          <slot name="description">
            {{ description }}
          </slot>
        </UiFormDescription>
      </div>
      <UiFormMessage :message="errorMessage" />
    </UiFormItem>
  </UiFormField>
</template>
